import HomePage from "./HomePage";
import InnerCirclePage from "./InnerCirclePage";
import InnerCircleArchivePage from "./InnerCircleArchivePage";
import LoginPage from "./LoginPage";
import NewsPage from "./NewsPage";
import NewsArchivePage from "./NewsArchivePage";
import PrizesPage from "./PrizesPage";
import ProductsPage from "./ProductsPage";
import ProfilePage from "./ProfilePage";
import RegistrationPage from "./RegistrationPage";
import ResetPasswordPage from "./ResetPasswordPage";
import RulesPreviewPage from "./RulesPreviewPage";
import PrivacyPage from "./PrivacyPage";

export default {
  HomePage,
  InnerCirclePage,
  InnerCircleArchivePage,
  LoginPage,
  NewsPage,
  NewsArchivePage,
  PrizesPage,
  ProductsPage,
  ProfilePage,
  ResetPasswordPage,
  RegistrationPage,
  RulesPreviewPage,
  PrivacyPage
};



// WEBPACK FOOTER //
// ./src/modules/pages/index.js